import {Component, OnInit, Input} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
// import { ProfileModel } from './MyProfile';
import { ModalEditUserProfile } from './ModalEditUserProfile';
import { ModalChangeMyProfilePhoto } from './ModalChangeMyProfilePhoto';
import { ModalDeleteUserProfilePhoto } from './ModalDeleteUserProfilePhoto';
import { App } from 'components/app/App';
import { ProfileLobby } from 'components/lobby/profileLobby/ProfileLobby';
import { Router } from '@angular/router';

@Component({
    selector: 'profile-basic-data',
    templateUrl: "../../../views/components/myProfile/profileBasicData.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class ProfileBasicData implements OnInit {

    @Input()
    profileModel: any;

    showBtnDelete: boolean;
    loading: boolean;
    errorMessage: string;
    profileImage: string;
    defaultImage: string;
    splitedHash = null;
    constructor(private modalService: NgbModal, private route: Router, private app:App, private profileLobby: ProfileLobby) {
        this.loading = false;
        this.showBtnDelete = false;
        this.defaultImage = "images/user2.jpg";
        this.splitedHash = this.route.url.split("/");
    }

    edit() {
        let modalRef: NgbModalRef = this.modalService.open(ModalEditUserProfile, {backdrop: "static"})
        modalRef.result.then(null, () => {
            this.verifyHash();
        });
    }

    changeProfilePhoto() {
        let modalRef: NgbModalRef = this.modalService.open(ModalChangeMyProfilePhoto, {backdrop: "static", size: "sm"})
        modalRef.result.then(null, (profileImageUrl: string) => {
            this.verifyHash();
        });
    }
    
    deleteProfilePhoto(){
        let modalRef: NgbModalRef = this.modalService.open(ModalDeleteUserProfilePhoto, {backdrop: "static", size: "sm"})
        modalRef.result.then(null, (response: any) => {
            this.verifyHash();
        });
    }

    verifyHash() {
        if (this.splitedHash[1] === 'app' && this.app.currentUserId==this.profileModel.userData.agentId) {
            this.app.getLoggedUserData()
        }
        // if(this.splitedHash[1] === '/home' && this.lobby.currentUserId==this.profileModel.userData.agentId)  {
        //     this.lobby.getLoggedUserData();
        // }
        if(this.splitedHash[1] === 'home' && this.profileLobby.currentUserId==this.profileModel.userData.agentId)  {
            this.profileLobby.getLoggedUserData();
        }
        this.profileModel.getLoggedUserData();
    }

    ngOnInit() {
        if (this.profileModel.userData.profileImageUrl == null || this.profileModel.userData.profileImageUrl == "") {
            this.profileImage = (this.profileModel.userData.initialsName == null || this.profileModel.userData.initialsName == "") ? this.defaultImage : null;
        } else {
            this.profileImage = this.profileModel.userData.profileImageUrl;
        }
    }
}